module.exports = __webpack_public_path__ + "img/slide2.d58aba8d.webp";